import { render, staticRenderFns } from "./TeachingWorkFrameModal.vue?vue&type=template&id=37644746&scoped=true"
import script from "./TeachingWorkFrameModal.vue?vue&type=script&lang=js"
export * from "./TeachingWorkFrameModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37644746",
  null
  
)

export default component.exports